type AppEnvironment = 'production' | 'staging' | 'local';

type AppEnvironmentConfig = {
  faviconHref: string;
  title: string;
};

const BASE_TITLE = 'NPT Labs';

const ENVIRONMENT_CONFIG: Record<AppEnvironment, AppEnvironmentConfig> = {
  production: {
    faviconHref: '/favicon.png',
    title: BASE_TITLE,
  },
  staging: {
    faviconHref: '/favicon-staging.png',
    title: `${BASE_TITLE} [Staging]`,
  },
  local: {
    faviconHref: '/favicon-local.png',
    title: `${BASE_TITLE} [Local]`,
  },
};

function getAppEnvironment(): AppEnvironment {
  const appEnv = (import.meta.env.VITE_APP_ENV || '').trim().toLowerCase();

  if (['staging', 'stage'].includes(appEnv)) {
    return 'staging';
  }

  if (['local', 'dev', 'development'].includes(appEnv) || (!appEnv && import.meta.env.DEV)) {
    return 'local';
  }

  return 'production';
}

function getOrCreateFaviconLink(): HTMLLinkElement {
  const existingLink = document.querySelector<HTMLLinkElement>('link[rel~="icon"]');

  if (existingLink) {
    return existingLink;
  }

  const link = document.createElement('link');
  link.rel = 'icon';
  document.head.appendChild(link);

  return link;
}

export function applyAppEnvironmentBranding() {
  const config = ENVIRONMENT_CONFIG[getAppEnvironment()];
  const faviconLink = getOrCreateFaviconLink();

  document.title = config.title;
  faviconLink.href = config.faviconHref;
  faviconLink.type = config.faviconHref.endsWith('.png') ? 'image/png' : 'image/x-icon';
}
